/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var FormatBoldOutlineIcon = function FormatBoldOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.6499H13C13.9113 10.6499 14.65 9.91117 14.65 8.9999C14.65 8.08863 13.9113 7.3499 13 7.3499H10L10 10.6499ZM7 13.3499V10.6499V7.3499V5.9999V4.6499H13C15.4024 4.6499 17.35 6.59746 17.35 8.9999C17.35 10.0381 16.9863 10.9914 16.3794 11.7392C17.2813 12.5362 17.85 13.7016 17.85 14.9999C17.85 17.4023 15.9024 19.3499 13.5 19.3499H7V17.9999V16.6499V13.3499ZM10 16.6499L10 13.3499H13H13.5C14.4113 13.3499 15.15 14.0886 15.15 14.9999C15.15 15.9112 14.4113 16.6499 13.5 16.6499L10 16.6499Z"
  }));
};
export default FormatBoldOutlineIcon;